import { render, staticRenderFns } from "./AspirationScores.vue?vue&type=template&id=28c9794d&"
import script from "./AspirationScores.vue?vue&type=script&lang=js&"
export * from "./AspirationScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports